import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const OverlayWrapper = styled(Box)(`
    position:fixed;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    z-index:10;
    background: rgba(0,0,0,0.02);
    display: flex;
    justify-content: center;
    align-items: center;
`)
